import { createSlice } from "@reduxjs/toolkit";

export enum StatusUploadSource {
  WAITING,
  UPLOADING,
  CANCEL,
}

const initialState = {
  addSourceNameIsValid: true,
  addSourceISBNIsValid: true,
  statusUploadSource: StatusUploadSource.WAITING,
};

const formAddSourceValidationSlice = createSlice({
  name: "formAddSourceValidationSlice",
  initialState,
  reducers: {
    setAddSourceNameValidation: (state, action) => {
      state.addSourceNameIsValid = action.payload;
    },
    setAddISBNNameValidation: (state, action) => {
      state.addSourceISBNIsValid = action.payload;
    },
    setStatusUploadSource: (state, action) => {
      state.statusUploadSource = action.payload;
    },
  },
});

export const {
  setAddSourceNameValidation,
  setAddISBNNameValidation,
  setStatusUploadSource,
} = formAddSourceValidationSlice.actions;

export default formAddSourceValidationSlice.reducer;
